import React from 'react';
import { Icon } from './Icon.js';
export const IconRepeat3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 15.5L2.5 19L6 22.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M18 8.5L21.5 5L18 1.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M22 20H2.5V18H20V11.7402L22 9.74023V20Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M21.5 6H4V12.2617L2 14.2617V4H21.5V6Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconRepeat3.js.map